export class TransactionTagGroup {
    key: string;
    name: string;

    // Client-side use only
    viewActiveItemsOnly: boolean;
    viewActiveGroupsOnly: boolean;

    constructor(key: string, name: string) {
        this.key = key;
        this.name = name;
    }
}
